module.exports = __webpack_public_path__ + "img/duanwu_ps_07.1a8b1dda.jpg";